const fakePosts = [
    {
        _id: '64243ddd907873df3d39b48f',
        userId: '64243d78907873df3d39b488',
        name :"Collecte de déchets",
        description:"Gros tas de déchets en tout genre près de la boulangerie Paul. J'en ai récupéré ce matin en allant au travail.",
        street:"15 place de la République",
        postalCode :"35000",
        city: "Rennes",
        trash_quantity_total: 150,
        trash_quantity_collected :12,
        createdAt: "2023-03-29T13:32:13.098+00:00",
        updatedAt: "2023-03-29T13:32:13.098+00:00",
        fakePost : true
    },
    {
        _id: '64243f9c907873df3d39b4b7',
        userId: '64243d78907873df3d39b488',
        name :"Collecte de déchets au bord de la plage",
        description:"Longue trainée de déchets apparue depuis ce weekend. Avec mes petits enfants on a pu en collecter un peu, mais on a besoin de bras pour rendre la plage propre.",
        street:"15 rue de la Falaise ",
        postalCode :"14530",
        city: "Luc-sur-Mer",
        trash_quantity_total: 150,
        trash_quantity_collected :12,
        createdAt: "2023-03-29T13:32:13.098+00:00",
        updatedAt: "2023-03-29T13:32:13.098+00:00",
        fakePost : true
    }
]

export default fakePosts;